import { PaymentMethod } from '~types'

export function renderCost(amount: number): string {
  if (amount < 0) {
    return `-$${Math.abs(amount / 100).toFixed(2)}`
  } else {
    return `$${(amount / 100).toFixed(2)}`
  }
}

type PaymentMethodInfo = [name: string, color: string]

export const methodColorMap: { [key in PaymentMethod]: PaymentMethodInfo } = {
  [PaymentMethod.BankPayment]: ['ACH / E-Check', '#22577A'],
  [PaymentMethod.CardPayment]: ['Credit Card', '#38A3A5'],
  [PaymentMethod.CashPayment]: ['Cash', '#57CC99'],
  [PaymentMethod.CheckPayment]: ['Check', '#80ED99'],
  [PaymentMethod.MoneyOrderPayment]: ['Money Order', '#FFF4CC'],
  [PaymentMethod.OtherPayment]: ['Other', '#C7F9CC'],
}

export const otherGraphColors = ['#cbebf8', '#86d0ee', '#1fa7e0', '#1a8dbd', '#115a79', '#072634']
